import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import list from '@/i18n/ELK/list.js'
import tabs from '@/i18n/ELK/tabs.js'
import anti from '@/i18n/ELK/anti.js'
import logs from '@/i18n/ELK/logs.js'
export default {
    // 列表点击查看
    ...list,
    ...logs,
    ...tabs,
    ...anti,
    // 垃圾病毒隔离区  
    //  ELK垃圾隔离列表
    wasteInsulate1: {
        tolname10: 'ELK归档邮件列表',
        tolname101: '归档邮件列表',
        tolname11: 'ELK实时过滤日志',
        tolname111: '实时过滤日志',
        tolname111_syslog: '系统原始日志',
        tolname111_syslog1: '队列号、Email、域名或者IP地址',
        tolname12: 'ELK实时投递日志',
        tolname121: '实时投递日志',
        tolname131: 'ELK详细路由日志',

        tolname1: 'ELK垃圾隔离列表',
        tolname: '垃圾隔离列表',
        envfrom: '信封发件人',
        envrcpt: '信封收件人',
        ip: 'ip地址',
        attach: '附件名',
        hdrfrom: '信头发件人',
        hdrto: '信头收件人',
        url: 'url',
        subject: '邮件主题',
        body: '	邮件正文',
        haspass: '是否放行',
        bigs: '	邮件大小',
        type: '查找类型',
        mid: 'mid',
        stage: '阶段',
        status: '状态及原因',
        minion_host: '集群节点',
        spam_reason: '拦截原因',
        startdate: '日期',
        zhi: '至',
        isl: '白名单',
        istls: '是否加密',
        isout: '进出方向',
        attnum: '附件数量',
        bccnum: '密送数量',
        alinknum: '链接数量',
        apt_state: '沙箱状态',
        attachment_size: '附件大小',

        delay_time: '延迟时间',
    },
    table: {
        search: '搜索',
        more: '更多',
        more1: '折叠',
        tls: 'tls',
        maildate: '日期',
        clusterhost: '集群节点',
        ID: 'ID',
        IP: 'IP地址',
        ENVFROM: '发件人',
        ENVRCPT: '收件人',
        ENVRCPT1: '收件人数',
        status: '发送状态',
        relay: '中继目标',
        reason: '发送失败原因',
        SUBJECT: '邮件主题',
        SHOW_REASON: '拦截原因',
        operate: '操作',
        mailsize: '大小',
        download: '打包下载',
        record: '导出记录',
        pass: '批量放行',
        pass1: '批量删除',
        look: '查看',
        sdata: '开始时间',
        enddata: '结束时间',
        show: '展示更多',
        yin: '隐藏',
        wl: '白名单',
        more_operations: '更多操作',

    },
    confirm: {
        ok: '确认',
        search: '查询',

        cancel: '取消',
        content: '你确认要退出系统吗？',
        logout: '退 出',
        deliver: '投递成功',
        transpond: '转发成功',
        refresh: "刷新",
    },

    ...zhLocale
}